import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import axios from 'axios';
import { getSiteKey } from '../components/RecaptchaProvider/RecaptchaProvider.utils';
import { getServerURL } from './urls';
export function sendContactFormEmail(_x) {
  return _sendContactFormEmail.apply(this, arguments);
}

function _sendContactFormEmail() {
  _sendContactFormEmail = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var businessType, businessId, locationId, name, email, emailSubject, message, contactOptIn, recaptchaToken, url, fullUrl;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            businessType = _ref.businessType, businessId = _ref.businessId, locationId = _ref.locationId, name = _ref.name, email = _ref.email, emailSubject = _ref.emailSubject, message = _ref.message, contactOptIn = _ref.contactOptIn, recaptchaToken = _ref.recaptchaToken;
            url = getServerURL();
            fullUrl = url + "businesses/" + businessType + "s/" + businessId + "/locations/" + locationId + "/email/";
            return _context.abrupt("return", axios.post(fullUrl, {
              contact_name: name,
              contact_email: email,
              contact_message: message,
              contact_opt_in: contactOptIn,
              email_subject: emailSubject,
              'recaptcha-token': recaptchaToken,
              'recaptcha-site-key': getSiteKey()
            }));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _sendContactFormEmail.apply(this, arguments);
}

export var searchDomains = function searchDomains(potentialDomain) {
  var headers = {
    'x-api-key': process.env.X_API_KEY || process.env.STORYBOOK_X_API_KEY
  };
  var url = getServerURL();
  return axios.get(url + "domains/search/details/?domain=" + potentialDomain, {
    headers: headers
  });
};